import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LearningPathProgressModel } from 'src/app/models/dashboard/learning-path-progress.model';
import { TableColumn } from 'src/app/models/table-column.model';
import { DashboardWidgetsDataService } from 'src/app/services/dashboard-widget-data.service';

@Component({
  selector: 'app-current-learning-path-status-widget',
  templateUrl: './current-learning-path-status-widget.component.html',
  styleUrl: './current-learning-path-status-widget.component.scss',
  standalone: false
})
export class CurrentLearningPathStatusWidgetComponent {
  learningPathsProgress: LearningPathProgressModel[] = [];
  
  learningPathsProgressData: any[] = [];
  
  learningPathsProgressColumns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.NAME'),
      dataField: 'name',
      dataType: 'string',
      disableFiltering: true,
      cssClass: 'width-200',
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS'),
      dataField: 'progress',
      dataType: 'string',
      disableFiltering: true,
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS') + ' %',
      dataField: 'progressPercentage',
      dataType: 'string',
      name: 'progressPercentage',
      calculateDisplayValue: (data: any): string => {
        return data.progressPercentage + ' %';
      },
      calculateSortValue: (data: any): number => {
        return data.progressPercentage;
      },
      disableFiltering: true,
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS-BAR'),
      dataField: 'progressPercentage',
      dataType: 'string',
      name: 'progressPercentageBar',
      cellTemplate: 'progressBullet',
      disableFiltering: true,
    },
  ];

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private dashboardWidgetsDataService: DashboardWidgetsDataService
  ) {
    
  }

  ngOnInit() {
     this.dashboardWidgetsDataService.getLearningPathsProgressCurrent().subscribe(data => {
      if (data) {
        this.learningPathsProgress = data;
        this.learningPathsProgressData = this.learningPathsProgress
        .map((data, index) => {
          return {
            id: data.learningPathId,
            name: data.learningPathName,
            progress: `${data.completedCourses} / ${
              data.openCourses + data.completedCourses
            }`,
            progressPercentage:
              data.openCourses + data.completedCourses > 0
                ? Math.min(
                    Math.round(
                      (data.completedCourses /
                        (data.openCourses + data.completedCourses)) *
                        100
                    ),
                    100
                  )
                : 0,
          };
        })
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      }
    });
  }

  onLearningPathClick(event: any) {
    this.router.navigate(['learning-paths', event]);
  }
}
